// ─────────────────────────────────────────────────────────────────────────────
// Footer — "Secured by Posteering" with a small lock glyph.
//
// Intentionally plain text for the Posteering wordmark in the footer (not
// the logo image). Reasoning: the header already carries the logo visually;
// a second logo in the footer competes for attention. Text-only footer
// reinforces the brand name without re-drawing focus.
//
// No links, no interactive elements. The footer is a trust marker, not
// navigation.
// ─────────────────────────────────────────────────────────────────────────────

export function Footer() {
  return (
    <footer className="footer">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <span>Secured by</span>
      <span className="footer-brand">POSTEERING</span>
    </footer>
  );
}
